import { keyframes } from "@emotion/react";
import { Badge } from "@mui/material";
import PropTypes from "prop-types";

const pulseAnimation = keyframes`
  0% {
    transform: scale(.8);
    opacity: 1;
  },
  20% {
    opacity: 1;
  },
  100% {
    transform: scale(2.4);
    opacity: 0;
  },
`;

function ActivityBadge({ color, active, size = "medium", children }) {
  return (
    <Badge
      variant="dot"
      slotProps={{
        badge: {
          sx: [
            {
              top: "unset",
              borderRadius: 6,
              height: size === "small" ? 12 : 14,
              width: size === "small" ? 12 : 14,
              bottom: -2,
              right: -2,
              transform: "scale(1)",
              border: (theme) => `2px solid ${theme.vars.palette.background.card}`,
              backgroundColor: color,
              color: color,
            },
            active && {
              "&::after": {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                animation: `${pulseAnimation} 1.2s infinite ease-in-out`,
                border: "1px solid currentColor",
                content: '""',
              },
            },
          ],
        },
      }}
    >
      {children}
    </Badge>
  );
}

ActivityBadge.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  active: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium"]),
};

export default ActivityBadge;
